import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import React from 'react'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { PublicSiteState } from '../../../../public_site.main.mod'
import { getClassName } from '../../../../cms/blocks/utils.gen'

export type PageNavigationBlockProps = {

}

export type PageNavigationBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  label_classname: string
  list_classname: string
  list_item_classname: string
  list_item_label_classname: string
  item_link_classname: string
  item_link_text_classname: string
}>

export function PageNavigationBlock<customBlockData, extra_images>(
  props: PageNavigationBlockProps,
  options?: { style?: PageNavigationBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
    mk_widget({
      run: _ => {

        let page_menu: string[] = public_state.page.blocks.toIndexedSeq()
          .filter((v: any) => v.value.fst.show_in_page_navigation)
          .map((v: any) => v.value.fst.navigation_title)
          .toArray()

        return (
          <nav className={getClassName(options, 'block_classname', '')} aria-label="direct link">
            <div className={getClassName(options, 'inner_classname', '')}>
              <ul className={getClassName(options, 'list_classname', '')}>
                <li className={getClassName(options,'list_item_label_classname', '')}>Direct naar:</li>
                {page_menu.map(v => <li className={getClassName(options, 'list_item_classname')} key={v}>
                  <a  className={getClassName(options, 'item_link_classname', '')} href={`#${v}`}><span  className={getClassName(options, 'item_link_text_classname', '')}>{v}</span></a>
                </li>)}
              </ul>
            </div>
          </nav>
        )
      }
    })
}



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/pageNavigation.tsx